import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * PARA-local in-memory score buffer for the LMS slideout.
 *
 * Kept under `para/` to avoid coupling to classic GT services or storage keys.
 */
@Injectable({ providedIn: 'root' })
export class ParaScoreStorageService implements OnDestroy {
	private readonly dataSubject = new BehaviorSubject<Record<string, any>>({});

	readonly data$ = this.dataSubject.asObservable();

	setData(data: any): void {
		const current = this.dataSubject.getValue();
		const id = data?.question?.id;
		if (id == null) return;
		this.dataSubject.next({ ...current, [String(id)]: data });
	}

	get count(): number {
		return Object.keys(this.dataSubject.getValue()).length;
	}

	get storedScores(): Record<string, any> {
		return this.dataSubject.getValue();
	}

	removeScore(questionId: string): void {
		const current = this.dataSubject.getValue();
		const { [String(questionId)]: _removed, ...rest } = current;
		this.dataSubject.next(rest);
	}

	clearData(): void {
		this.dataSubject.next({});
	}

	ngOnDestroy(): void {
		this.dataSubject.complete();
	}
}

